import React, { useState } from 'react';
import axios from 'axios';
import { MailWarning } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EmailVerifyBanner = () => {
  const { user, token } = useAuth();
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  if (!user || user.email_verified !== false) return null;

  const resend = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/auth/resend-verification`, {},
        { headers: { Authorization: `Bearer ${token}` } });
      setSent(true);
      toast.success('Verification email sent. Check your inbox.');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Could not send the email. Try again in a minute.');
    }
    setBusy(false);
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 bg-amber-500 text-navy-900 shadow-[0_-2px_10px_rgba(0,0,0,0.15)]" data-testid="email-verify-banner">
      <div className="max-w-6xl mx-auto px-4 py-2 flex items-center gap-2 text-xs sm:text-sm">
        <MailWarning className="w-4 h-4 flex-shrink-0" />
        <span className="flex-1 truncate">Verify your email address to secure your account.</span>
        {sent ? (
          <span className="font-semibold whitespace-nowrap" data-testid="verify-banner-sent">Email sent ✓</span>
        ) : (
          <button onClick={resend} disabled={busy}
                  className="font-bold underline underline-offset-2 whitespace-nowrap disabled:opacity-50"
                  data-testid="verify-banner-resend-btn">
            {busy ? 'Sending...' : 'Resend verification email'}
          </button>
        )}
      </div>
    </div>
  );
};
